import FetchService from "./Shared/FetchService";
const baseURL = "/aviso/courseSectionSchedulerBreak";
const selectedBreaksURL = "/aviso/courseSectionSchedulerSelectedBreak";
export default class CourseSectionSchedulerBreakService {
    static getBreaks() {
        return FetchService.getSingleResponse(baseURL + "/getBreaks");
    }
    static saveBreak(schedulerBreak) {
        return FetchService.postSingleResponse(baseURL + "/saveBreak", Object.assign({}, schedulerBreak));
    }
    static deleteBreak(schedulerBreakId) {
        return FetchService.postSingleResponse(baseURL + "/deleteBreak", {
            id: schedulerBreakId,
        });
    }
    static getSelectedBreaks(termId) {
        return FetchService.getSingleResponse(selectedBreaksURL + "/getSelectedBreaks", { termId });
    }
    static selectBreak(termId, schedulerBreakId) {
        return FetchService.postSingleResponse(selectedBreaksURL + "/selectBreak", {
            termId,
            schedulerBreakId,
        });
    }
    static unselectBreak(termId, schedulerBreakId) {
        return FetchService.postSingleResponse(selectedBreaksURL + "/unselectBreak", { termId, schedulerBreakId });
    }
}
